import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createBootstrap } from 'bootstrap-vue-next'
import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import { install as installRecaptcha } from 'vue3-recaptcha-v2'

// Import main SCSS (includes variables, Bootstrap, and custom styles in correct order)
import './styles/main.scss'

import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(createBootstrap())
app.use(installRecaptcha, {
  sitekey: import.meta.env.VITE_RECAPTCHA_SITE_KEY || ''
})

// Configure Vue Toastification
app.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  showCloseButtonOnHover: false,
  hideProgressBar: false
})

app.mount('#app')
